import { useEffect } from 'react';

export const usePageTitle = (title: string, description?: string, isReady: boolean = true) => {
    useEffect(() => {
        document.title = title;
        
        if (description) {
            let metaDesc = document.querySelector('meta[name="description"]');
            if (!metaDesc) {
                metaDesc = document.createElement('meta');
                metaDesc.setAttribute('name', 'description');
                document.head.appendChild(metaDesc);
            }
            metaDesc.setAttribute('content', description);
        }

        // Canonical URL 설정
        let canonicalEl = document.querySelector('link[rel="canonical"]');
        if (!canonicalEl) {
            canonicalEl = document.createElement('link');
            canonicalEl.setAttribute('rel', 'canonical');
            document.head.appendChild(canonicalEl);
        }
        const currentUrl = window.location.origin + window.location.pathname;
        canonicalEl.setAttribute('href', currentUrl);

        // Prerender.io 캡처 시점 제어
        if (isReady) {
            (window as any).prerenderReady = true;
        } else {
            (window as any).prerenderReady = false;

            // API 호출 지연/실패 등으로 렌더링 대기가 무한히 지속되는 것을 방지하기 위해 3초 후 강제 완료
            const timeoutId = setTimeout(() => {
                (window as any).prerenderReady = true;
            }, 3000);

            return () => {
                clearTimeout(timeoutId);
            };
        }
    }, [title, description, isReady]);
};

export default usePageTitle;
